import { sendErrorToSentry } from '@/helpers/utils';
import store from '@/store';
import { StoreMutations } from '@/helpers/enums';
import { SeverityLevel } from '@sentry/vue';
import Clarity from "@microsoft/clarity";

export class LaundryheapApiError extends Error {
  public readonly message: string;
  private readonly key: string;

  constructor(
    severity: SeverityLevel,
    sentryKey?: string | null,
    message?: string
  ) {
    super(message);

    this.key = sentryKey || 'Graphql error, error key';
    this.message = message || 'Unknown message';
    store.commit(
      StoreMutations.setAppError,
      sentryKey ? message : 'There was an error, please contact the support.'
    );
    store.commit(StoreMutations.hideLoader);

    if (sentryKey) {
      Clarity.setTag('error_info_key_str', this.key);
      Clarity.setTag('error_info_message', this.message);
    } else {
      sendErrorToSentry(this.key, { message: this.message }, severity);
    }
  }
}
